import React from "react";
import {useHistory} from 'react-router-dom';
import {CrossComponentValueManager} from "../common/CrossComponentValueManager";
import {AdminHeader} from "./AdminHeader";
import {LeaveWithoutSavingWarningModal} from "../common/LeaveWithoutSavingWarningModal";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {UserConfirmationFunction} from "../../routes";

export interface GlobalNavigator {
    navigateTo: Function;
    goBack: Function;
}

export interface GlobalContextType {
    navigator: GlobalNavigator;
    confirmBeforeNavValueManager: object | undefined;
    navWarningDisplayValueSetter: object | undefined;
    confirmBeforeNavValueSetter: object | undefined;
}

export let GlobalContext = React.createContext<GlobalContextType>({
    navigator: {
        navigateTo: () => null,
        goBack: () => null,
    },
    confirmBeforeNavValueManager: undefined,
    navWarningDisplayValueSetter: undefined,
    confirmBeforeNavValueSetter: undefined
});

let navWarningDisplayValueManager = new CrossComponentValueManager();
let navWarningDisplayValueSetter = navWarningDisplayValueManager.createValueSetter();

let confirmBeforeNavValueManager = new CrossComponentValueManager();
let confirmBeforeNavValueSetter = confirmBeforeNavValueManager.createValueSetter();

interface AdminFrameProps {
    setUserConfirmationFunction: (functionToUse: UserConfirmationFunction) => void;
    children: React.ReactNode;
}

export let AdminFrame = function (props: AdminFrameProps) {
    let history = useHistory();

    props.setUserConfirmationFunction(function (message, callback) {
        // this function gets called by BrowserRouter to determine what to show to the user if
        // navigation is blocked by a Prompt. It's meant to return a component for display,
        // but I have it instead triggering an externally-defined component to display (in the
        // same wrapper component as the prompt).

        navWarningDisplayValueSetter({
            showLeaveWithoutSavingWarningModal: true,
            getUserConfirmationCallback: function (allowNavigation: boolean) {
                window.setTimeout(function () {
                    if (allowNavigation) {
                        LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                    }
                    callback(allowNavigation);
                }, 0);
            },
        })
    });

    let context = {
        navigator: {
            navigateTo: function (url: string) {
                history.push(url);
            },
            goBack: function () {
                history.goBack();
            }
        },
        confirmBeforeNavValueManager: confirmBeforeNavValueManager,
        navWarningDisplayValueSetter: navWarningDisplayValueSetter,
        confirmBeforeNavValueSetter: confirmBeforeNavValueSetter,
    };

    return (
        <GlobalContext.Provider value={context}>
            <div className="admin-frame">
                <AdminHeader/>
                <div className="admin-page-content">
                    {props.children}
                </div>
            </div>
            <LeaveWithoutSavingWarningModal
                navWarningDisplayValueManager={navWarningDisplayValueManager}
                confirmBeforeNavValueManager={confirmBeforeNavValueManager}
            />
        </GlobalContext.Provider>
    );
};

